<template lang="pug">
div
	p.form-section
		| Credit Card Information

		fieldset
			.field-title(:class="{errorContactLabel: !card.nameOnCard && isCheckout}") {{ $t('payment.card.nameOnCard') }} *
			.each-field-contact: b-form-input.all-fields(v-model='card.nameOnCard', required="", :class="{errorInField: !card.nameOnCard && isCheckout}")

		// .fieldset-flex
			.an-material.nopadding
				md-field.full
					label {{ $t('payment.card.paymentMethod') }}
					md-select#paymentMethod.selectpicker(v-model='card.paymentMethod')
						md-option(v-for='(paymentMethod, index) in paymentMethods', :value="paymentMethod.value", :key="index" ) {{ paymentMethod.label }}
		fieldset
			.field-title(:class="{errorContactLabel: !card.nameOnCard && isCheckout}") {{ $t('payment.card.cardNumber') }} *
			.each-field-contact: b-form-input.all-fields(v-model='card.cardNumber', type="text", required="", :class="{errorInField: !card.cardNumber && isCheckout}")

		fieldset
			.state-zip-row
				.left-side
					.field-title(:class="{errorContactLabel: !card.nameOnCard && isCheckout}") Expiration Month *
					.each-field-contact
						b-form-select#expireMonth.all-fields(v-model='card.expireMonth', placeholder="", :class="{errorInField: !card.expireMonth && isCheckout}")
							option(v-for='(month, index) in monthsList', :value="month.value", :key="index") {{ month.label }}
				.left-side
					.field-title(:class="{errorContactLabel: !card.nameOnCard && isCheckout}") Expiration Year *
					.each-field-contact
						b-form-select#expireYear.all-fields(v-model='card.expireYear', :class="{errorInField: !card.expireYear && isCheckout}")
							option(v-for='(year, index) in yearsList', :value="year", :key="index") {{ year }}
				.right-side
					.field-title(:class="{errorContactLabel: !card.nameOnCard && isCheckout}") CVV *
					.each-field-contact: b-form-input.all-fields(v-model="card.cvv", :class="{errorInField: !card.cvv && isCheckout}")

		// .fieldset-flex
			//.an-material.nopadding
			//	md-field.full
			//		label {{ $t('payment.card.expirationDate') }}
			.an-material.nopadding
				md-field.full
					md-select#expireMonth.selectpicker(v-model='card.expireMonth', placeholder="Expiration Month")
						md-option(v-for='(month, index) in monthsList', :value="month.value", :key="index") {{ month.label }}
			.an-material.nopadding
				md-field.full
					md-select#expireYear.selectpicker(v-model='card.expireYear', placeholder="Expiration Year")
						md-option(v-for='(year, index) in yearsList', :value="year", :key="index") {{ year }}

			.an-material.nopadding
				md-field.full
					label CVV
					md-input(type='number', v-model='card.cvv', required="")
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

export default {
	name: 'card-form',
	props: ['data', 'isCheckout'],
	data () {
		return {
			card: {
				paymentMethod: '1'
			},
			// Payment Method list
			paymentMethods: [
				{value: '1', label: 'Visa'},
				{value: '2', label: 'Master Card'},
				{value: '3', label: 'American Express'}
			],

			// List of months
			monthsList: [],

			// List of years
			yearsList: []
		}
	},
	created () {
		// Available products
		// List of next 9 years
		let year = new Date().getFullYear()

		for (let x = 0; x <= 9; x++) {
			this.yearsList.push(year + x)
		}

		// List of months
		this.monthsList = _.map(moment.months(), function (monthName) {
			return { label: monthName, value: moment().month(monthName).format('MM') }
		})

		if (_.isNil(this.data)) {
			this.card = {
				nameOnCard: '',
				paymentMethod: '1',
				creditCardNumber: '',
				cvv: '',
				expireMonth: moment().format('MM'),
				expireYear: moment().format('YYYY')
			}
		} else {
			this.card = this.data
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/checkout/tabs-components/card-form.vue